var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCertificationServiceMainMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 92,
    viewBox: "0 0 147 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2025_280)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.814,
    y: 27.1055,
    width: 89.6353,
    height: 56.8915,
    fill: "#6299FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7905 55.5491L104.766 27.0153L104.766 84.0829L61.7905 55.5491Z",
    fill: "#8DB5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7905 55.5491L14.8147 27.0153L14.8147 84.0829L57.7905 55.5491Z",
    fill: "#8DB5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5947 58.5392C63.464 63.0374 55.7943 63.0374 50.6636 58.5392L14.8115 27.1074H104.447L68.5947 58.5392Z",
    fill: "#C4D8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.149,
    y: 0.900978,
    width: 67.9613,
    height: 87.1976,
    rx: 2.80001,
    fill: "#F3F3F3",
    stroke: "#EDEDED",
    strokeWidth: 0.800002
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.792,
    y: 53.2959,
    width: 52.7976,
    height: 3.51982,
    rx: 1.75991,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.792,
    y: 43.9121,
    width: 52.7976,
    height: 3.51982,
    rx: 1.75991,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.792,
    y: 62.6836,
    width: 52.7976,
    height: 3.51982,
    rx: 1.75991,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.792,
    y: 72.0742,
    width: 37.5449,
    height: 3.51982,
    rx: 1.75991,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.292 18.0351L110.142 13.6465L99.8331 18.0351V23.124C99.8331 26.0653 99.58 29.1466 103.111 33.8154C104.976 36.2803 108.575 37.7682 110.142 38.204C111.327 38.0483 114.36 36.9527 117.014 33.8154C120.292 29.9403 120.306 25.3805 120.292 23.124V18.0351Z",
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.968 26.6144L108.696 29.7978L114.608 22.5215",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2025_280",
    x: 13.2115,
    y: 0.500977,
    width: 132.899,
    height: 91.1981,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.800002
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2025_280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2025_280",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCertificationServiceMainMobile);
export default __webpack_public_path__ + "static/media/IcCertificationServiceMainMobile.9bb5ca718bb4ead48685c876fbbdaea9.svg";
export { ForwardRef as ReactComponent };